import IconSecurityLocker from './IconSecurityLocker'

export default IconSecurityLocker
